import { Truck, Phone, Clock } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "../../lib/constants";
import { trackPhoneClick } from "../../lib/gtag";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#1E293B] text-slate-300 py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5 mb-5">
              <span className="w-10 h-10 rounded-xl bg-[#16A34A] flex items-center justify-center">
                <Truck className="w-5 h-5 text-white" />
              </span>
              <span className="leading-tight">
                <span className="block font-display font-extrabold text-white tracking-tight text-lg">Tiszta Tér</span>
                <span className="block text-[10px] uppercase tracking-[0.22em] text-slate-400 font-semibold">Lomtalanítás</span>
              </span>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed max-w-sm">
              Profi lomtalanítás, lakáskiürítés és hulladékelszállítás Budapesten és Pest megyében.
              Gyorsan, tisztán, rejtett költségek nélkül.
            </p>
          </div>
          <div className="md:col-span-4">
            <h3 className="font-display font-bold text-white text-sm uppercase tracking-[0.2em] mb-5">Kapcsolat</h3>
            <ul className="space-y-4 text-sm">
              <li>
                <a data-testid="footer-phone-link" href={PHONE_TEL} onClick={trackPhoneClick} className="flex items-center gap-3 hover:text-green-400 transition-colors">
                  <Phone className="w-4 h-4 text-[#16A34A]" />
                  <span className="font-bold text-white">{PHONE_DISPLAY}</span>
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Clock className="w-4 h-4 text-[#16A34A]" />
                Nyitvatartás: H–V: 08:00 – 20:00
              </li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <h3 className="font-display font-bold text-white text-sm uppercase tracking-[0.2em] mb-5">Szolgáltatások</h3>
            <ul className="space-y-3 text-sm text-slate-400">
              <li>Lakás- és pinceürítés</li>
              <li>Építési törmelék elszállítás</li>
              <li>Iroda & raktár lomtalanítás</li>
              <li>Kert & zöldhulladék elszállítás</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-700/60 mt-14 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500" data-testid="footer-copyright">
            © 2026 Tiszta Tér Lomtalanítás. Minden jog fenntartva.
          </p>
          <p className="text-xs text-slate-500">Környezetbarát hulladékkezelés • Számlaképes szolgáltatás</p>
        </div>
      </div>
    </footer>
  );
}
